import {Modal} from "flowbite-react";
import {HiOutlineExclamation} from "react-icons/hi";
import CustomButton from "../../../components/common/CustomButton";
import React from "react";
import {useProjectService} from "../../../services";
import {useSelector} from "react-redux";

interface MergeWarningModalProps {
  showMergeWarningModal: boolean;
  setShowMergeWarningModal: (showMergeWarningModal: boolean) => void;
  onRefresh: () => void;
}

const MergeWarningModal: React.FC<MergeWarningModalProps> = ({showMergeWarningModal, setShowMergeWarningModal, onRefresh}) => {
  const {
    saveSimulationMerge,
  } = useProjectService();

  const {
    currentEntityId,
    simulation
  } = useSelector((state: any) => state.timeline);

  const handleMergeConfirm = async () => {
    setShowMergeWarningModal(false);

    if (currentEntityId) {
      await saveSimulationMerge(currentEntityId, simulation);
      onRefresh();
    }
  };

  return (
    <Modal show={showMergeWarningModal} onClose={() => setShowMergeWarningModal(false)} className="h-[100vh] z-[9999]">
      <Modal.Header>Merge</Modal.Header>
      <Modal.Body>
        <div className="space-y-6">
          <div className="items-center text-center flex flex-col justify-center dark:text-white text-gray-600 text-base font-normal font-['Inter'] leading-snug">
            <HiOutlineExclamation className="text-6xl" /><br/>
            You are about to Merge your Simulation to the Live version.<br/>
            Once merged, you can still go back to the previous version in the Version history feature.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="items-center flex justify-center">
        <CustomButton className="bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white" onClick={handleMergeConfirm}>Ok</CustomButton>
        <CustomButton variant="cancel" onClick={() => setShowMergeWarningModal(false)}>Cancel</CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default MergeWarningModal;